<template>
  <div>
    <hr>
    <section class="content nomination-section" v-if="Object.keys(categories).length">
      <div class="columns">
        <div class="column is-3"><h2>Nominations</h2></div>
        <div class="column is-9">
          <p class="is-size-6">
            Start typing the name you want to nominate.
            After typing a few letters, a list of names will appear.
            Once you see the name of your nominee, click it.
          </p>
        </div>
      </div>
      <div
        v-for="(categoryList, header, index) in categories"
        class="nomination-section"
        :key="index"
      >
        <div class="nomination-section-header">
          <h4 class="title" v-html="header" />
          <template v-if="ads && ads[header] && ads[header].length > 0">
            <section v-for="(ad, index) in ads[header]" :key="index">
              <img class="ad" :src="ad">
              <small>Advertisement</small>
            </section>
          </template>
        </div>
        <div
          v-for="(category, index) in categoryList"
          :key="index"
          class="field"
        >
          <div class="field-label is-normal has-text-left">
            <label class="label" v-html="category" />
          </div>
          <div class="field-body">
            <div
              v-for="i in votesPerCategory"
              :key="i"
              class="field"
            >
              <p class="control">
                <input
                  type="text"
                  :id="`nom-${slugify(category)}-${i}`"
                  :name="`nom-${slugify(category)}-${i}`"
                  :data-category="`${slugify(category)}`"
                  :data-category_id="`${i}`"
                  class="input vote-field"
                  :placeholder="getNominationNumber(i)"
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <WriteIn />
    <hr>
  </div>
</template>

<script>
import autocomplete from 'autocomplete.js';
import algoliasearch from 'algoliasearch';
import { mapGetters } from 'vuex';
import slug from '@/lib/slug';

export default {
  computed: {
    ...mapGetters({
      categories: 'categories',
    }),
    ads() {
      return this.$store.state.categories.ADS;
    },
    votesPerCategory() {
      return this.$store.state.votes_per_category;
    },
  },
  methods: {
    slugify(string) {
      return slug(string);
    },
    getNominationNumber(number) {
      if (number === 2) return 'Second Nomination';
      if (number === 3) return 'Third Nomination';
      if (number === 4) return 'Fourth Nomination';
      if (number === 5) return 'Fifth Nomination';
      return 'First Nomination';
    },
    newHitsSource(index, params) {
      return function doSearch(query, cb) {
        index
          .search(query, params)
          .then((res) => cb(res.hits, res))
          .catch((err) => {
            console.error(err);
            cb([]);
          });
      };
    },
  },
  mounted() {
    const algoliaIndex = algoliasearch(
      this.$store.state.algolia_app_id,
      this.$store.state.algolia_api_key,
    ).initIndex(this.$store.state.algolia_index);

    [...document.querySelectorAll('.vote-field')].forEach((input) => {
      autocomplete(input, {
        hint: false,
        openOnFocus: true,
        autoselectOnBlur: true,
        // debug: true, // Uncomment this to keep the dropdown open
      }, [
        {
          source: this.newHitsSource(algoliaIndex, { hitsPerPage: 12 }),
          displayKey: 'name',
          debounce: 300,
          templates: {
            suggestion: (suggestion) => (`<span>${suggestion._highlightResult.name.value}</span>`),
            footer: () => ('<a href="#writeIn" class="no-nominee">Can\'t find your nominee? CLICK HERE or scroll down to add.</a>'),
            empty: () => ' ',
          },
        },
      ])
        .on('autocomplete:empty', (e) => {
          e.target.setAttribute('empty', true);
        })
        .on('autocomplete:selected', (e, suggestion) => {
          e.target.setAttribute('empty', false);
          Array.from({ length: this.votesPerCategory }, (v, i) => (i + 1).toString())
            .forEach((vote) => {
              if (
                document.getElementById(`nom-${e.target.dataset.category}-${vote}`)
                  .value === e.target.value
                && vote !== e.target.dataset.category_id
              ) {
                e.target.value = '';
                e.target.setAttribute('empty', true);
              }
            });

          this.$store.dispatch('setNomination', {
            name: e.target.name,
            value: suggestion.id,
          });
        });
      input.addEventListener('blur', (e) => {
        // Prevents the text from coming back on blur. Thanks, Algolia.
        if (e.target.getAttribute('empty') === 'true') {
          e.target.value = '';
        }
        this.$store.dispatch('updateVoteCount');
      });
      // https://gist.github.com/6174/6062387
      // eslint-disable-next-line
      input.autocomplete = [...Array(5)].map(i => (~~(Math.random() * 36)).toString(36)).join('');
    });
  },
  components: {
    WriteIn: () => import('@/components/WriteIn.vue'),
  },
};
</script>
